<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="インターネットサイト設定参照(Type4)"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row ga-1 justify-end">
                <v-btn color="primary" @click="toChange">変更</v-btn>
              </v-col>
            </v-row>
            <v-tabs v-model="tabValue" grow hide-slider class="mt-3">
              <v-tab text="アドレス" value="address"></v-tab>
              <v-tab text="FQDN" value="fqdn"></v-tab>
            </v-tabs>
            <v-tabs-window v-model="tabValue">
              <!-- アドレスタブ-->
              <v-tabs-window-item value="address">
                <app-table
                  :fields="addressList.fields"
                  :items="addressList.items"
                  primary-key="ipAddressId"
                  :tr-class="() => undefined"
                  density="compact"
                >
                  <!-- アドレス名-->
                  <template #cell(ipAddressName)="data">
                    {{ $filter.emptyTo(data.value, "-") }}
                  </template>
                  <!-- ポリシー使用有無-->
                  <template #cell(isPolicyInUse)="data">
                    {{ $filter.enumTo(data.value, "isPolicyInUse") }}
                  </template>
                </app-table>
              </v-tabs-window-item>

              <!-- FQDNタブ-->
              <v-tabs-window-item value="fqdn">
                <app-table
                  :fields="fqdnList.fields"
                  :items="fqdnList.items"
                  primary-key="fqdnId"
                  :tr-class="() => undefined"
                  density="compact"
                >
                  <!-- FQDN名-->
                  <template #cell(fqdnName)="data">
                    {{ $filter.emptyTo(data.value, "-") }}
                  </template>
                  <!-- ポリシー使用有無-->
                  <template #cell(isPolicyInUse)="data">
                    {{ $filter.enumTo(data.value, "isPolicyInUse") }}
                  </template>
                </app-table>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import type { AppTableHeader } from "@/components/AppTable.vue";
import type {
  Type4InternetAddress,
  Type4InternetFQDN,
  Type4InternetSite,
} from "@/apis/Type4SiteApi";
import { defineComponent } from "vue";
import type { ApplianceInfo } from "@/apis/ContractApi";
import Type4InternetSiteModify from "@/modals/type4/Type4InternetSiteModify.vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "Type4InternetSiteReference",
  props: {
    internetSite: {
      type: Object as PropType<Type4InternetSite>,
      required: true,
    },
    type4Id: {
      type: String as PropType<ApplianceInfo["type4Id"]>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "address",
      addressList: {
        fields: [
          {
            key: "ipAddressName",
            title: "アドレス名",
          },
          {
            key: "ipAddress",
            title: "アドレス",
            width: "200px",
          },
          {
            key: "isPolicyInUse",
            title: "ポリシー使用有無",
            width: "200px",
          },
        ] as AppTableHeader<Type4InternetAddress>[],
        items: [] as Type4InternetAddress[],
      },
      fqdnList: {
        fields: [
          {
            key: "fqdnName",
            title: "FQDN名",
          },
          {
            key: "fqdn",
            title: "FQDN",
            width: "200px",
          },
          {
            key: "isPolicyInUse",
            title: "ポリシー使用有無",
            width: "200px",
          },
        ] as AppTableHeader<Type4InternetFQDN>[],
        items: [] as Type4InternetFQDN[],
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    /** 初期化機能 */
    load() {
      this.addressList.items = this.internetSite.addressList;
      this.fqdnList.items = this.internetSite.fqdnList;
    },
    async toChange() {
      await this.$modal.show(Type4InternetSiteModify, {
        internetSite: this.internetSite,
        type4Id: this.type4Id,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
